<template>
  <div class="main">
    <div class="main_header">
        <div class="header_item">
            <span class="header_label">姓名：</span>
            <el-input v-model="search.realName" clearable placeholder="请输入姓名"></el-input>
        </div>
        <div class="header_item">
            <span class="header_label">手机号：</span>
            <el-input v-model="search.phone" clearable placeholder="请输入手机号"></el-input>
        </div>
        <div class="header_item">
            <span class="header_label">班组：</span>
            <el-select v-model="search.groupId" placeholder="请选择班组" clearable filterable>
                <el-option
                v-for="item in optionsGroup"
                :key="item.groupId"
                :label="item.groupName"
                :value="item.groupId">
                </el-option>
            </el-select>
        </div>
        <div class="header_item">
            <el-button   :size="size" icon="el-icon-search" v-if="showButton('search')" @click="searchButtonInfo(true)">查询</el-button>
            <el-button  :size="size" icon="el-icon-back" v-if="showButton('search')" @click="$emit('update:showPrint', false)">返回</el-button>
        </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="dataList"
        height="100%">
        <el-table-column align="center" label="序号" width="60">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column label="头像" align="center" show-overflow-tooltip>
            <template >
                <div>
                    <el-image
                        style="width: 50px; height: 50px;"
                        src="https://htpipe.thhy-tj.com/group1/M00/00/03/bx5d1GRlfmCAEmAPAAAFoOEW2dU397.png"
                        fit="contain">
                    </el-image>
                </div>
            </template>
        </el-table-column>
        <el-table-column prop="realName" label="姓名" align="center"></el-table-column>
        <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
        <el-table-column prop="groupName" label="班组" align="center"></el-table-column>
        <el-table-column prop="posName" label="岗位" align="center"></el-table-column>
        <el-table-column prop="createTime" label="培训时间" align="center"></el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { buttonPinia } from '../../../pinia/index';
import { changeSize} from '../../../plugins/public'; // 导入节流、动态切换组件尺寸方法
  export default {
    name: 'TrainRecord',
    props:{
        showPrint: {
            type: Boolean
        },
        rowsData:{
            type:Object
        }
    },
    data() {
      return {
        size: changeSize(), // 组件尺寸
        pageNum: 1,
        pageSize: 10,
        search:{},//查询条件
        total: 0,
        loading: false,
        dataList: [], //打印信息
        optionsGroup:[],//班组信息
        baseUrl: process.env.VUE_APP_BASE_URL
      }
    },
    watch: {
      asyncVisible(bol) {
        if(!bol) {
          this.ruleForm = {};
          this.$refs.ruleForm.resetFields();
        }
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.searchButtonInfo(true)
      that.getAllGroups()
    },
    methods: {
     //获得班组
     getAllGroups(){
        this.$api.Personnerl.GETDEPARTMENTDATA({}).then(res=>{
            if(res.statusMsg === 'ok'){
                res.data.forEach(item=>{
                  this.optionsGroup.push(...item.groups)
                })
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
     },
      // 查询按钮列表信息
      searchButtonInfo(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        let params = Object.assign({},this.search,{
            pageNum: this.pageNum,
            pageSize: this.pageSize,
            secureId:this.rowsData.secureId,
        })
        this.loading = true;
          this.$api.Safety.getEnactRecords(params).then((res) => {
            if(res.statusMsg === 'ok') {
                this.total = res.data.total;
                this.dataList = res.data.list;
                this.loading = false;
            }else{
              this.$message.warning(res.statusMsg)
            }
          })
      },
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },      
      // 切换页数
      changePageNum(page) {
        this.pageNum = page;
        this.searchButtonInfo();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchButtonInfo();
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '../../../style/layout-main.scss';
</style>
